import { render, staticRenderFns } from "./marketOrder.vue?vue&type=template&id=ce7aab64&scoped=true"
import script from "./marketOrder.vue?vue&type=script&lang=js"
export * from "./marketOrder.vue?vue&type=script&lang=js"
import style0 from "./marketOrder.vue?vue&type=style&index=0&id=ce7aab64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7aab64",
  null
  
)

export default component.exports